"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const container_1 = __importDefault(require("./container"));
const tms_class_1 = __importDefault(require("./tms.class"));
function getBreadcrumb() {
  const jsonld = document.querySelector('script#jsonld_BREADCRUMB');
  if (!jsonld) {
    return;
  }
  try {
    const jsonData = JSON.parse(jsonld.textContent);
    const items = jsonData.itemListElement;
    const startIndex = 1;
    const tradProducts = new Set(['Produits', 'Productos', 'Prodotti', 'Produtos', 'Produkty']);
    if (!Array.isArray(items)) return;
    for (let i = startIndex, j = 1; i < items.length; i++, j++) {
      const name = items[i].item.name;
      if (tradProducts.has(name)) {
        j--;
      } else {
        window.tc_vars['cdl_fa_breadcrumb_' + j] = name;
      }
    }
    window.tc_vars.cdl_fa_page_name = items[items.length - 1].item.name;
  } catch (error) {
    return;
  }
}
function main() {
  window.lm.DOMReady(() => {
    const tms = new ((0, tms_class_1.default)(window.lm.Composant))();
    (0, container_1.default)(tms.target && JSON.parse(tms.target.dataset.containers));
    Object.assign(window.tms, tms.init(window.tms._q));
    getBreadcrumb();
    delete window.tms._q;
  });
}
if (document.currentScript) {
  main();
}
exports.default = main;